import React from 'react';

export default function AlmacenPanel({ location, showLocation = true }) {
  const displayNames = {
    'popayan': 'Popayán',
    'santander-de-quilichao': 'Santander de Quilichao',
  };
  const title = displayNames[location] || location;

  return (
    <div className="text-gray-800">
      <h2 className="text-2xl font-semibold mb-2">Almacen</h2>
      {showLocation && (
        <p className="text-gray-700">Sede: {title}</p>
      )}
      <div className="mt-4 text-sm text-gray-600">
        Control de inventario, entradas/salidas y trazabilidad de productos.
      </div>
    </div>
  );
}
